import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../common/Button";

/**
 * Temporary React component that has been used to display an error message to the user
 * when he tries to access a page that should require the ADMIN role to view.
 * @param info
 * @returns {JSX.Element}
 * @constructor
 */
export default function AccessDenied({ info }) {
    const history = useHistory();

    return (
        <div className="text-center p-6">
            <div>{info}</div>
            <Button
                onClick={history.goBack}
                className="mt-4"
            >
                Gå tillbaka
            </Button>
        </div>
    );
}
